<template>
  <div class="info_block_holder row">
    <a href="#">
      <div class="social_block facebook col-xs-6">
        <a v-bind:href="facebookLink" id="fblink"  target="_blank"><div class="col-xs-4"><span class="social_icon icon-facebook"></span></div><div class="col-xs-7"><span>SHARE</span></div></a>
      </div>
    </a>
    <div class="social_block twitter col-xs-6">
      <a v-bind:href="twitterLink" id="twitlink" target="_blank"><div class="col-xs-4"><span class="social_icon icon-twitter"></span></div><div class="col-xs-7"><span>TWEET</span></div></a>
    </div>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  data: function () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      athlete: 'focusedAthlete'
    }),
    facebookLink () {
      return 'https://www.facebook.com/dialog/feed?' +
        'app_id=183206202046089' +
        '&display=popup&amp;' +
        '&link=' + window.location.href
    },
    twitterLink () {
      return 'https://twitter.com/intent/tweet?' +
        'url=' + window.location.href +
        '&via=sportraxs'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/athlete/athleteShare.vue